import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  // No 'Home' entry: the app registers a single route (/swap) and everything else
  // redirects to it, so a Home link pointed at the same page Trade already opens.
  // Restore it only alongside a real landing page.
  {
    label: 'Trade',
    icon: 'TradeIcon',
    href: '/swap',
  },
  // LiberaDex is swap-only by design - no liquidity provision/pool management UI,
  // and Farms/Pools (LBC staking) hidden for now.
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: 'https://liberadex.finance/lottery',
  // },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: 'https://liberadex.finance/nft',
  // },
  // {
  //   label: 'Teams & Profile',
  //   icon: 'GroupsIcon',
  //   calloutClass: 'rainbow',
  //   items: [
  //     {
  //       label: 'Leaderboard',
  //       href: 'https://liberadex.finance/teams',
  //     },
  //     {
  //       label: 'Task Center',
  //       href: 'https://liberadex.finance/profile/tasks',
  //     },
  //     {
  //       label: 'Your Profile',
  //       href: 'https://liberadex.finance/profile',
  //     },
  //   ],
  // },
  // {
  //   label: 'Info',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'Overview',
  //       href: 'https://info.liberadex.finance',
  //     },
  //     {
  //       label: 'Tokens',
  //       href: 'https://info.liberadex.finance/tokens',
  //     },
  //     {
  //       label: 'Pairs',
  //       href: 'https://info.liberadex.finance/pairs',
  //     },
  //     {
  //       label: 'Accounts',
  //       href: 'https://info.liberadex.finance/accounts',
  //     },
  //   ],
  // },
  // {
  //   label: 'IFO',
  //   icon: 'IfoIcon',
  //   href: 'https://liberadex.finance/ifo',
  // },
  // {
  //   label: 'More',
  //   icon: 'MoreIcon',
  //   items: [
  //     {
  //       label: 'Voting',
  //       href: 'https://voting.liberadex.finance',
  //     },
  //     {
  //       label: 'Github',
  //       href: 'https://github.com/liberadex',
  //     },
  //     {
  //       label: 'Docs',
  //       href: 'https://docs.liberadex.finance',
  //     },
  //     {
  //       label: 'Blog',
  //       href: 'https://blog.liberadex.finance',
  //     },
  //   ],
  // },
]

export default config
